import React from 'react';
import { AlertTriangle, RefreshCw, ArrowLeft } from 'lucide-react';

const SIZE_TO_CLASSES = {
  small: 'p-6',
  medium: 'p-8',
  large: 'p-12 min-h-[50vh]',
};

const ErrorState = ({
  title = 'Ocorreu um erro',
  description = null,
  error = null,
  onRetry = null,
  onGoBack = null,
  size = 'medium',
  className = '',
}) => {
  const containerSize = SIZE_TO_CLASSES[size] || SIZE_TO_CLASSES.medium;

  return (
    <div
      className={`flex flex-col items-center justify-center text-center ${containerSize} ${className}`}
    >
      <div className="mb-4">
        <AlertTriangle className="w-16 h-16 text-red-500 mx-auto" />
      </div>

      <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>

      {description && <p className="text-sm text-gray-600 mb-4 max-w-md">{description}</p>}

      {error && process.env.NODE_ENV === 'development' && (
        <pre className="text-left text-xs bg-gray-100 p-3 rounded-md max-w-xl overflow-auto mb-4 whitespace-pre-wrap">
          {typeof error === 'string' ? error : error?.message || JSON.stringify(error, null, 2)}
        </pre>
      )}

      <div className="flex items-center gap-3">
        {onRetry && (
          <button
            onClick={onRetry}
            className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            <RefreshCw className="w-4 h-4" />
            Tentar Novamente
          </button>
        )}

        {onGoBack && (
          <button
            onClick={onGoBack}
            className="flex items-center gap-2 px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Voltar
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorState;
